export default __webpack_public_path__ + "images/8aecae61dbc9d192a14c8b34e69d8f05.png";